import { isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import getLEPackageItemTotals from '../accommodation/getLEPackageItemTotals'
import { getItemUniqueKey } from '../accommodation/cart'
import { isHotelPackage } from 'lib/offer/offerTypes'

function getAccommodationItemViewLoyaltyUpgradeAvailability(
  offer: App.Offer,
  item: App.Checkout.LEAccommodationItem,
  calendarsByOccupancy: App.CalendarState['calendarsByOccupancy'],
  availableRatesByOccupancy: { [offerId: string]: App.OfferAvailableRatesByOccupancy },
): App.Checkout.AccommodationItemViewLoyaltyUpgradeAvailability | undefined {
  if (!isInstantBookingLEHotelItem(item)) return

  const uniqueKey = getItemUniqueKey(item)
  const originPackage = offer.packages.find(pkg => pkg.uniqueKey === uniqueKey)

  if (!originPackage || !isHotelPackage(originPackage)) return

  const originTotals = getLEPackageItemTotals(
    offer,
    originPackage,
    item.checkIn,
    item.checkOut,
    item.occupancy,
    undefined,
    calendarsByOccupancy,
    availableRatesByOccupancy,
  )

  if (!originTotals) return

  const originPrimaryTitle = originPackage.roomType.name

  const roomUpgradePackageUniqueKey = originPackage.loyalty.upgradeTargetsUniqueKeys?.room
  const roomUpgradePackage = roomUpgradePackageUniqueKey ? offer.packages.find(pkg => pkg.uniqueKey === roomUpgradePackageUniqueKey) : undefined
  const roomUpgradePrimaryTitle = roomUpgradePackage?.roomType?.name ?? ''
  const roomUpgradeTotals = roomUpgradePackage ? getLEPackageItemTotals(
    offer,
    roomUpgradePackage,
    item.checkIn,
    item.checkOut,
    item.occupancy,
    undefined,
    calendarsByOccupancy,
    availableRatesByOccupancy,
  ) : undefined

  const packageUpgradePackageUniqueKey = originPackage.loyalty.upgradeTargetsUniqueKeys?.package
  const packageUpgradePackage = packageUpgradePackageUniqueKey ? offer.packages.find(pkg => pkg.uniqueKey === packageUpgradePackageUniqueKey) : undefined
  const packageUpgradePrimaryTitle = packageUpgradePackage?.roomType?.name ?? ''
  const packageUpgradeTotals = packageUpgradePackage ? getLEPackageItemTotals(
    offer,
    packageUpgradePackage,
    item.checkIn,
    item.checkOut,
    item.occupancy,
    undefined,
    calendarsByOccupancy,
    availableRatesByOccupancy,
  ) : undefined

  if (!roomUpgradePackage && !packageUpgradePackage) return

  if (
    (roomUpgradePackage && roomUpgradeTotals?.isAvailable && isHotelPackage(roomUpgradePackage)) &&
    (packageUpgradePackage && packageUpgradeTotals?.isAvailable && isHotelPackage(packageUpgradePackage)
    )) {
    return {
      upgradeAvailabilityType: 'room-and-package',
      originPackage,
      originTotals,
      originPrimaryTitle,
      roomUpgradePackage,
      roomUpgradeTotals,
      roomUpgradePrimaryTitle,
      packageUpgradePackage,
      packageUpgradeTotals,
      packageUpgradePrimaryTitle,
    }
  }

  if (packageUpgradePackage && packageUpgradeTotals?.isAvailable && isHotelPackage(packageUpgradePackage)) {
    return {
      upgradeAvailabilityType: 'package-only',
      originPackage,
      originTotals,
      originPrimaryTitle,
      packageUpgradePackage,
      packageUpgradeTotals,
      packageUpgradePrimaryTitle,
    }
  }

  if (roomUpgradePackage && roomUpgradeTotals?.isAvailable && isHotelPackage(roomUpgradePackage)) {
    return {
      upgradeAvailabilityType: 'room-only',
      originPackage,
      originTotals,
      originPrimaryTitle,
      roomUpgradePackage,
      roomUpgradeTotals,
      roomUpgradePrimaryTitle,
    }
  }
}

export default getAccommodationItemViewLoyaltyUpgradeAvailability
